import { FullScreenBackgroundContainer } from "@/components/container/full-screen-background-container";
import { IonSpinner } from "@ionic/react";

/**
 * The `/` route. The native container loads this on launch, so it must render
 * immediately. It is now a passive spinner: the actual entry redirect (to
 * /overview, /get-started, or /splash-screen depending on auth + onboarding state)
 * is owned by the global `AuthRouteGuard`. Keeping the navigation here too would
 * reintroduce a second redirector that fights the guard — the original cause of the
 * /overview ↔ /get-started flicker loop.
 */
const RootRedirect = () => {
  return (
    <FullScreenBackgroundContainer
      imageClassName="bg-splash-screen-background"
      className="flex flex-col items-center justify-center"
      backdrop={false}
    >
      <IonSpinner name="crescent" className="h-12 w-12 text-white" />
    </FullScreenBackgroundContainer>
  );
};

export default RootRedirect;
